import { render, staticRenderFns } from "./cuspre.vue?vue&type=template&id=0bbae8cb&scoped=true&"
import script from "./cuspre.vue?vue&type=script&lang=tsx&"
export * from "./cuspre.vue?vue&type=script&lang=tsx&"
import style0 from "./cuspre.vue?vue&type=style&index=0&id=0bbae8cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbae8cb",
  null
  
)

export default component.exports